export enum SignalRequestTypes {
  UpsertSignalRequest = 'signals.upsert.request',
  UpsertSignalSuccess = 'signals.upsert.success',
  UpsertSignalFailure = 'signals.upsert.failure',
  GetAllSignalRequest = 'signals.get.all.request',
  GetAllSignalSuccess = 'signals.get.all.success',
  GetAllSignalFailure = 'signals.get.all.failure',
  DeleteSignalRequest = 'signals.delete.request',
  DeleteSignalSuccess = 'signals.delete.success',
  DeleteSignalFailure = 'signals.delete.failure',
}
